import React from 'react';
import { View } from '@uncinc/react-drupal-core';

import { TitleHeaderBlock } from '../../../components';

const ParagraphLatestNews = ({ entity }) => {
  return (
    <TitleHeaderBlock
      title={entity.getIn(['field_title', 0, 'value'], '')}
      body={entity.getIn(['field_paragraph_text', 0, 'value'], '')}
      linkText={entity.getIn(['field_link', 0, 'title'], 'ahum')}
      linkUrl={entity.getIn(['field_link', 0, 'alias']) ? entity.getIn(['field_link', 0, 'alias']) : entity.getIn(['field_link', 0, 'uri'])}
    >
      {/* View content that is being rendered. */}
      <View
        id="news"
        display="pinned_recent"
      />
    </TitleHeaderBlock>
  );
};

export default ParagraphLatestNews;


